export const useCalcLotsParams = (bonusAmount, currentLotsAmount) => {
    const lotsSize = bonusAmount / 2;
    const lotsDiff = (lotsSize - currentLotsAmount).toFixed(2)
    const lotsWon = (currentLotsAmount || 0).toFixed(2);
    const lotsLeft = lotsDiff < 0
        ? 0
        : lotsDiff;
    const percent = currentLotsAmount / lotsSize * 100;
    const percentValueWon = percent > 100
        ? 100
        : percent;
    const percentValueLeft = 100 - percentValueWon;
    return { percentValueWon, lotsWon, percentValueLeft, lotsLeft }
}